var _line, _line2, _line3, _mask, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 8.5,
    x2: 5.5,
    y2: 11.5,
    stroke: "#EE3E54",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 8.5,
    x2: 10.5,
    y2: 11.5,
    stroke: "#EE3E54",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 11.5,
    x2: 11.5,
    y2: 11.5,
    stroke: "#EE3E54",
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 8,
    height: 4,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 8,
    height: 4,
    rx: 0.5,
    stroke: "#EE3E54",
    strokeWidth: 2,
    mask: "url(#path-4-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.67f112d7b951e19d9d5a35a25de4bf2c.svg";
export { ForwardRef as ReactComponent };